import { render } from "./Decision.vue?vue&type=template&id=208ff2ee&scoped=true"
import script from "./Decision.vue?vue&type=script&lang=ts"
export * from "./Decision.vue?vue&type=script&lang=ts"

import "./Decision.vue?vue&type=style&index=0&id=208ff2ee&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-208ff2ee"

export default script